import React from "react";
import { motion } from "framer-motion";

function AuditProcess() {
  const steps = [
    {
      number: "01",
      title: "Discovery",
      description:
        "Tell us about your website, industry and goals."
    },
    {
      number: "02",
      title: "Deep Analysis",
      description:
        "We review performance, visibility and growth opportunities."
    },
    {
      number: "03",
      title: "Opportunity Mapping",
      description:
        "Key issues and opportunities are prioritized."
    },
    {
      number: "04",
      title: "Growth Recommendations",
      description:
        "Receive actionable recommendations tailored to your business."
    }
  ];

  return (
    <section
      style={{
        padding: "100px 24px",
        background: "#fff"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto"
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "70px"
          }}
        >
          <span
            style={{
              color: "#21b573",
              fontWeight: 700,
              textTransform:
                "uppercase"
            }}
          >
            Process
          </span>

          <h2
            style={{
              color: "#002147",
              fontWeight: 700,
              marginTop: "18px",
              fontSize:
                "clamp(2rem,4vw,3.2rem)"
            }}
          >
            How The Audit Works
          </h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(260px,1fr))",
            gap: "24px"
          }}
        >
          {steps.map((step) => (
            <motion.div
              key={step.number}
              whileHover={{
                y: -8
              }}
              style={{
                background: "#fff",
                border:
                  "1px solid rgba(0,33,71,.08)",
                borderRadius: "24px",
                padding: "36px",
                boxShadow:
                  "0 15px 40px rgba(0,33,71,.06)"
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  fontWeight: 700,
                  color: "#21b573",
                  marginBottom: "20px"
                }}
              >
                {step.number}
              </div>

              <h4
                style={{
                  color: "#002147",
                  fontWeight: 700,
                  marginBottom: "16px"
                }}
              >
                {step.title}
              </h4>

              <p
                style={{
                  color: "#6e6e73",
                  lineHeight: 1.8,
                  marginBottom: 0
                }}
              >
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AuditProcess;